import { useRestPost, UseRestPostMutationOptions } from 'scbk-services';
import { APIS } from 'scbk-servicing/constants/apiPaths';
import {
    SvcGstLstListAccountSpeedSearchRequest,
    SvcGstLstListAccountSpeedSearchResponse,
    SvcGstLstListDemandAccountTransactionInquiryRequest,
    SvcGstLstListDemandAccountTransactionInquiryResponse,
    SvcGstLstListDepositandFundTransactionInquiryRequest,
    SvcGstLstListDepositandFundTransactionInquiryResponse,
    SvcGstLstListForeignCurrencyTransactionInquiryRequest,
    SvcGstLstListForeignCurrencyTransactionInquiryResponse,
    SvcGstLstListSpeedAccountListInquiryRequest,
    SvcGstLstListSpeedAccountListInquiryResponse,
} from 'scbk-servicing/types/api';

/**
 *  스피드조회 > 계좌목록 Hook *
 */
export const useSvcGstLstListAccountSpeedSearch = (
    mutationOptions?: UseRestPostMutationOptions<
        SvcGstLstListAccountSpeedSearchRequest,
        SvcGstLstListAccountSpeedSearchResponse
    >,
) => {
    return useRestPost<
        SvcGstLstListAccountSpeedSearchRequest,
        SvcGstLstListAccountSpeedSearchResponse
    >(
        {
            endpoint: APIS.services.guest.findList.listAccountSpeedSearch,
        },
        mutationOptions,
    );
};

/**
 *  스피드조회 > 목록조회 Hook *
 */
export const useSvcGstLstListSpeedAccountListInquiry = (
    mutationOptions?: UseRestPostMutationOptions<
        SvcGstLstListSpeedAccountListInquiryRequest,
        SvcGstLstListSpeedAccountListInquiryResponse
    >,
) => {
    return useRestPost<
        SvcGstLstListSpeedAccountListInquiryRequest,
        SvcGstLstListSpeedAccountListInquiryResponse
    >(
        {
            endpoint: APIS.services.guest.findList.listSpeedAccountListInquiry,
        },
        mutationOptions,
    );
};

/**
 *  스피드조회 > 예금펀드거래내역조회 Hook *
 */
export const useSvcGstLstListDepositandFundTransactionInquiry = (
    mutationOptions?: UseRestPostMutationOptions<
        SvcGstLstListDepositandFundTransactionInquiryRequest,
        SvcGstLstListDepositandFundTransactionInquiryResponse
    >,
) => {
    return useRestPost<
        SvcGstLstListDepositandFundTransactionInquiryRequest,
        SvcGstLstListDepositandFundTransactionInquiryResponse
    >(
        {
            endpoint: APIS.services.guest.findList.listDepositandFundTransactionInquiry,
        },
        mutationOptions,
    );
};

/**
 *  스피드조회 > 요구불거래내역조회 Hook *
 */
export const useSvcGstLstListDemandAccountTransactionInquiry = (
    mutationOptions?: UseRestPostMutationOptions<
        SvcGstLstListDemandAccountTransactionInquiryRequest,
        SvcGstLstListDemandAccountTransactionInquiryResponse
    >,
) => {
    return useRestPost<
        SvcGstLstListDemandAccountTransactionInquiryRequest,
        SvcGstLstListDemandAccountTransactionInquiryResponse
    >(
        {
            endpoint: APIS.services.guest.findList.listDemandAccountTransactionInquiry,
        },
        mutationOptions,
    );
};

/**
 *  스피드조회 > 외화거래내역조회 Hook *
 */
export const useSvcGstLstListForeignCurrencyTransactionInquiry = (
    mutationOptions?: UseRestPostMutationOptions<
        SvcGstLstListForeignCurrencyTransactionInquiryRequest,
        SvcGstLstListForeignCurrencyTransactionInquiryResponse
    >,
) => {
    return useRestPost<
        SvcGstLstListForeignCurrencyTransactionInquiryRequest,
        SvcGstLstListForeignCurrencyTransactionInquiryResponse
    >(
        {
            endpoint: APIS.services.guest.findList.listForeignCurrencyTransactionInquiry,
        },
        mutationOptions,
    );
};
